export enum OrdersField {
    externalIdField = "externalId",
    marketIdField = "marketId",
}